module.exports = __webpack_public_path__ + "img/【诊改行动】合作升级，共驱共赢！上电智联助力爱驰威开启轻量级数字化改造项目.8ce8814f.jpg";